import firebase from 'firebase';

/* const vapidKey2: string | undefined = process.env
  .REACT_APP_FIREBASE_VAPID_KEY as string;
const apiKey2: string | undefined = process.env
  .REACT_APP_FIREBASE_API_KEY as string;
const authDomain2: string | undefined = process.env
  .REACT_APP_FIREBASE_AUTH_DOMAIN as string;
const projectId2: string | undefined = process.env
  .REACT_APP_FIREBASE_PROJECT_ID as string;
const storageBucket2: string | undefined = process.env
  .REACT_APP_FIREBASE_STORAGE_BUCKET as string;
const messagingSenderId2: string | undefined = process.env
  .REACT_APP_FIREBASE_MESSAGING_SENDER_ID as string;
const appId2: string | undefined = process.env
  .REACT_APP_FIREBASE_APPID as string;
const measurementId2: string | undefined = process.env
  .REACT_APP_FIREBASE_MEASUREMENT_ID as string;

export const firebaseConfig3 = {
  vapidKey: vapidKey2,
  apiKey: apiKey2,
  authDomain: authDomain2,
  projectId: projectId2,
  storageBucket: storageBucket2,
  messagingSenderId: messagingSenderId2,
  appId: appId2,
  measurementId: measurementId2
}; */

export const firebaseConfig = {
  vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
export const onMessageListener = () =>
  new Promise((resolve) => {
    firebase.messaging().onMessage((payload) => {
      resolve(payload);
    });
  });
